import React from 'react';
import needLogin from '../assets/images/needLogin.png';
import {useNavigate} from "react-router-dom";
import {TbLogin} from "react-icons/tb";
import {GiReturnArrow} from "react-icons/gi";
import Header from "./Header";



export default function NeedLogin() {
    const navigate = useNavigate();

    return (

        <section className="container-fluid vertical-center loading "  >
            <Header title='احراز هویت' hasBack={true} />
            <div className="row mobile-size-option">

                <div className="col-12 text-center mb-3 ">
                    <img src={needLogin} alt="Loading" className='w-75 black-white'/>
                </div>
                <div className="col-12 text-center text-big-2 ">
                   برای دسترسی به این صفحه نیاز به ورود به سامانه دارید.
                </div>

                <div className="col-12 text-center  mt-5 px-5">

                  <button className='btn bg-primary-color text-white w-100'
                  onClick={() => {
                      navigate('/login');
                  }}
                  >

                      ورود به سامانه

                      <TbLogin className='mx-2 text-big-2' />
                  </button>
                  <button className='btn btn-outline-secondary text-small-2 w-100 mt-4 '
                          onClick={() => {
                              window.history.back()
                          }}
                  >
                     انصراف و بازگشت
                      <GiReturnArrow  className='mx-2' />
                  </button>

                </div>
            </div>
        </section>

    );
}

